import { Select } from "@primer/react";
import { ITongHopKyRequest } from "../../model/request/tong-hop-diem/ITongHopKyRequest";
import { apiClient } from "../apiClient";

export const TONG_HOP_KY_ENDPOINT = "diem/tong-hop-ky";
export const tongHopKyApi = {
    Select: (request: ITongHopKyRequest) => apiClient.post(`${TONG_HOP_KY_ENDPOINT}`, request),
}